export default __webpack_public_path__ + "static/media/GRT.ea6b2c81.png";